// extracted by mini-css-extract-plugin
export default {"spinner":"Loader_spinner__DoK9l","spin":"Loader_spin__+6Qzf","container":"Loader_container__KTkEd"};